import styled from 'styled-components';

export const Section = styled.section`
  padding: 6rem 2rem;
  background: ${({ theme }) => theme.color.white};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 0rem 2rem;
  }
`;

export const Container = styled.div`
  max-width: 143rem;
  margin: 0 auto;

  padding-top: 2rem;
  padding-bottom: 2rem;

  border-bottom: 4px solid #f3fcfe;
`;

export const Content = styled.div`
  width: 100%;
  order: 1;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    order: 2;
  }
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size30};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height125};
  margin-bottom: 1rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size26};
    line-height: ${({ theme }) => theme.lineHeight.height140};
  }
`;

export const HighlightTitle = styled.h3`
  color: ${({ theme }) => theme.color.mobilityBlue};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size30};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height125};
  margin-bottom: 1rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size26};
    line-height: ${({ theme }) => theme.lineHeight.height140};
  }
`;
